import axios from 'axios';
import type { ApiHealthResponse } from './types';
import { API_HEALTH_TIMEOUT_MS } from './types';

function trimTrailingSlashes(value: string): string {
  let end = value.length;
  while (end > 0 && value.codePointAt(end - 1) === 47) end--;
  return end === value.length ? value : value.slice(0, end);
}

function getApiBaseUrl(): string {
  return trimTrailingSlashes(process.env.NEXT_PUBLIC_REST_API_ENDPOINT ?? '');
}

export async function fetchApiHealth(): Promise<ApiHealthResponse> {
  const baseUrl = getApiBaseUrl();

  if (!baseUrl) {
    throw new Error('NEXT_PUBLIC_REST_API_ENDPOINT is not configured');
  }

  const { data } = await axios.get<ApiHealthResponse>(`${baseUrl}/health`, {
    timeout: API_HEALTH_TIMEOUT_MS,
    validateStatus: () => true,
  });

  return data;
}
